import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';

export const accessToken = () => {
  let token = localStorage?.getItem('webex_token')
    ? localStorage?.getItem('webex_token')
    : '';
  return token;
};
export const CLIENT_ID =
  'Cb85be7e65caa2fc982575fb5162067b8271909cff8b90b01c461fa0b43434e96';
export const CLIENT_SECRET =
  '5771059fd15a7f9e0f404c3939b234944d867e307f7ec20038c03442eff42e57';
export const REDIRECT_URI = 'http://localhost:3000/admin/session-managemnt';
export const REDIRECT_URI_DEV =
  'https://objective-kilby.164-52-220-175.plesk.page/session-managemnt';
export const REDIRECT_URI_PROD =
  'https://admin.thetncollege.com/admin/session-managemnt';

export const scope =
  'spark-admin%3Abroadworks_subscribers_write%20meeting%3Aadmin_participants_read%20spark%3Apeople_write%20spark-admin%3Awholesale_customers_write%20spark-admin%3Aworkspace_metrics_read%20spark-admin%3Awholesale_billing_reports_read%20spark-admin%3Atelephony_pstn_write%20spark-admin%3Avideo_mesh_api_webhook_write%20spark%3Aplaces_read%20cjp%3Aconfig_write%20meeting%3Aadmin_config_write%20spark-admin%3Arecordings_read%20spark-compliance%3Amessages_read%20spark-admin%3Aworkspaces_write%20spark-compliance%3Ameetings_write%20spark-admin%3Alocations_write%20meeting%3Aadmin_schedule_write%20identity%3Aplaceonetimepassword_create%20spark-admin%3Aorganizations_write%20spark-admin%3Atelephony_pstn_read%20spark%3Adevices_write%20spark-admin%3Awholesale_sub_partners_write%20cjp%3Aconfig_read%20spark-admin%3Abroadworks_billing_reports_write%20spark-admin%3Acall_qualities_read%20spark%3Aapplications_token%20spark%3Akms%20spark-admin%3Awholesale_sub_partners_read%20spark%3Awebrtc_calling%20spark-admin%3Amessages_read%20application%3Awebhooks_write%20spark-admin%3Awholesale_subscribers_read%20meeting%3Aadmin_config_read%20spark%3Atelephony_config_write%20meeting%3Aparticipants_read%20Identity%3Acontact%20spark-admin%3Awholesale_billing_reports_write%20spark-admin%3Avideo_mesh_api_read%20spark-compliance%3Awebhooks_write%20spark-admin%3Aorganizations_read%20spark-compliance%3Ateam_memberships_read%20meeting%3Aschedules_write%20spark-admin%3Avideo_mesh_api_write%20spark-admin%3Arecordings_write%20identity%3Aorganizations_rw%20identity%3Aorganizations_read%20spark-admin%3Adevices_read%20cjp%3Auser%20cjp%3Aconfig%20spark-admin%3Atelephony_config_write%20spark%3Arecordings_write%20spark-admin%3Abroadworks_enterprises_read%20spark%3Acalls_read%20meeting%3Arecordings_write%20spark%3Adevices_read%20spark-compliance%3Aevents_read%20spark-admin%3Aresource_group_memberships_read%20identity%3Apeople_rw%20spark-admin%3Aresource_group_memberships_write%20application%3Awebhooks_read%20spark-admin%3Ahybrid_connectors_read%20spark-compliance%3Ateams_read%20spark-admin%3Aplaces_write%20spark-admin%3Alicenses_read%20spark%3Aplaces_write%20meeting%3Aadmin_preferences_write%20spark%3Aall%20meeting%3Aadmin_preferences_read%20analytics%3Aread_all%20spark-admin%3Apeople_write%20spark%3Aorganizations_read%20spark-admin%3Aplaces_read%20dedicated-instance-uc%3Aadmin_perfmon_read%20spark-compliance%3Ateam_memberships_write%20identity%3Agroups_read%20identity%3Atokens_read%20spark-compliance%3Arecordings_read%20spark-admin%3Adevices_write%20spark%3Acalls_write%20Identity%3Aone_time_password%20spark-admin%3Aevents_read%20spark-admin%3Aworkspace_locations_read%20spark-compliance%3Arecordings_write%20spark%3Axapi_commands%20spark-compliance%3Awebhooks_read%20spark-compliance%3Amessages_write%20spark-admin%3Awholesale_customers_read%20spark%3Axsi%20spark-admin%3Areports_read%20meeting%3Aparticipants_write%20spark-admin%3Apeople_read%20meeting%3Aadmin_transcripts_read%20spark-compliance%3Amemberships_read%20spark-admin%3Aresource_groups_read%20meeting%3Arecordings_read%20spark-admin%3Alocations_read%20meeting%3Apreferences_write%20meeting%3Aadmin_recordings_read%20identity%3Atokens_write%20meeting%3Atranscripts_read%20spark-admin%3Amessages_write%20spark%3Axapi_statuses%20spark-admin%3Awholesale_subscribers_write%20spark-admin%3Acalling_cdr_read%20spark%3Arecordings_read%20spark-admin%3Ahybrid_clusters_read%20meeting%3Acontrols_read%20spark-admin%3Aworkspace_locations_write%20spark-admin%3Abroadworks_billing_reports_read%20spark-admin%3Atelephony_config_read%20spark-admin%3Abroadworks_enterprises_write%20meeting%3Aadmin_schedule_read%20spark-compliance%3Amemberships_write%20meeting%3Aschedules_read%20spark-admin%3Aroles_read%20spark-compliance%3Ameetings_read%20meeting%3Apreferences_read%20identity%3Apeople_read%20spark-admin%3Aworkspaces_read%20spark%3Atelephony_config_read%20spark-compliance%3Arooms_read%20spark-admin%3Abroadworks_subscribers_read%20identity%3Agroups_rw%20spark-admin%3Areports_write%20meeting%3Acontrols_write%20audit%3Aevents_read%20meeting%3Aadmin_recordings_write%20spark-compliance%3Arooms_write%20spark%3Akms&state=set_state_here';

export const Webex_Base_Url = 'https://webexapis.com';

export const teacherScope = `meeting%3Aadmin_participants_read%20meeting%3Aadmin_participants_write%20meeting%3Aparticipants_read%20meeting%3Aparticipants_write%20meeting%3Acontrols_read%20meeting%3Acontrols_write%20meeting%3Aadmin_schedule_write%20meeting%3Aadmin_schedule_read%20meeting%3Aadmin_preferences_write%20meeting%3Aadmin_preferences_read%20spark%3Akms&state=set_state_here`;

export const updateAdminIntegrationToken = async (newTokenData) => {
  try {
    const querySnapshot = await db
      .collection('adminItegrationAppDetails')
      .limit(1)
      .get();

    if (querySnapshot.empty) {
      console.log('No document found in adminItegrationAppDetails.');
      return;
    }

    const doc = querySnapshot.docs[0];
    const docId = doc.id;

    await db.collection('adminItegrationAppDetails').doc(docId).update({
      refreshToken: newTokenData.refreshToken,
      accessToken: newTokenData.accessToken,
      expiresIn: newTokenData.expiresIn,
      lastUpdated: new Date().toISOString(),
    });

    console.log(`Document ${docId} updated successfully.`);
  } catch (error) {
    console.error('Error updating admin integration token:', error);
  }
};

export const updateTeacherIntegrationToken = async (
  teacherId,
  newTokenData
) => {
  try {
    const querySnapshot = await db
      .collection('zSystemUsers')
      .where('_uniqueID', '==', teacherId)
      .where('isTeacher', '==', true)
      .get();

    if (querySnapshot.empty) {
      console.log(`No matching document found for _uniqueID: ${teacherId}`);
      return;
    }

    const doc = querySnapshot.docs[0];
    const docId = doc.id;
    await db
      .collection('zSystemUsers')
      .doc(docId)
      .update({
        intrigrationTokenData: {
          accessToken: newTokenData.accessToken,
          expiresIn: newTokenData.expiresIn,
          lastUpdated: newTokenData.lastUpdated,
          refreshToken: newTokenData.refreshToken,
          type: 'intrigration',
        },
      });

    console.log(
      `Document ${docId} updated successfully for _uniqueID: ${teacherId}`
    );
  } catch (error) {
    console.error('Error updating document:', error);
  }
};
